<template>
    <div class="custom-inner-header">
        <span>{{ params.displayName }}</span>
        <f-tooltip :placement="'bottom'">
            <template #title>
                <div class="tooltip-content">
                    <span>{{localizer.Localize('LandscapeManagement_Include_Tenant_Tooltip_Text')}}</span>
                </div>
            </template>
            <f-icon class="info-icon" icon="info" :size="16" />
        </f-tooltip>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            localizer: new Localizer(this.$store),
        };
    },
});
</script>

<style>
.custom-inner-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
}

.custom-inner-header .info-icon {
    cursor: pointer;
}

.ant-tooltip-inner:has(.tooltip-content) {
    min-width: 150px;
    background: var(--accent-color5) !important;
    color: var(--background-primary);
}
</style>
